import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {TypeCount} from 'src/app/model/cms-vod-core/content-controller/type-count-model';
import {ContentIssueType, ContentIssueTypeCreate} from 'src/app/model/cms-vod-core/validation-event-models/content-issue-type.model';
import {ContentIssueTypeCount} from 'src/app/model/cms-vod-core/validation-event-models/content-issue-type-count.model';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContentIssueTypeService {
  readonly contentIssueTypeApi = environment.endPoint + ApplicationPackage.CMS_VOD + Service.ISSUETYPE;

  constructor(private http: HttpClient) {}

  getAllContentIssueTypes(): Observable<ContentIssueType[]> {
    return this.http.get<ContentIssueType[]>(this.contentIssueTypeApi);
  }

  getContentIssueTypeById(issueTypeId: number): Observable<ContentIssueType> {
    return this.http.get<ContentIssueType>(this.contentIssueTypeApi + `/${issueTypeId}`);
  }

  createContentIssueType(contentIssueTypeCreate: ContentIssueTypeCreate): Observable<ContentIssueTypeCreate> {
    return this.http.post<ContentIssueTypeCreate>(this.contentIssueTypeApi, contentIssueTypeCreate);
  }

  updateContentIssueType(contentIssueType: ContentIssueType): Observable<ContentIssueType> {
    return this.http.post<ContentIssueType>(this.contentIssueTypeApi, contentIssueType);
  }

  deleteContentIssueType(issueTypeId: number): Observable<string> {
    return this.http.delete<string>(this.contentIssueTypeApi + `/${issueTypeId}`);
  }

  getContentCountByContentIssueTypeByContent(): Observable<TypeCount[]> {
    return this.http.get<TypeCount[]>(this.contentIssueTypeApi + `/count/content`);
  }
  getCatchupCountByContentIssueTypeByContent(): Observable<TypeCount[]> {
    return this.http.get<TypeCount[]>(this.contentIssueTypeApi + `/count/catchup`);
  }

  getContentIssueTypeCount(startTime?: number, endTime?: number): Observable<ContentIssueTypeCount[]> {
    let queryParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (startTime) {
      queryParams = queryParams.set('startTime', <any>startTime);
    }
    if (endTime) {
      queryParams = queryParams.set('endTime', <any>endTime);
    }
    return this.http.get<ContentIssueTypeCount[]>(this.contentIssueTypeApi + `/count/contentissuetype`, {params: queryParams});
  }
  getContentIssueTypeReport(startTime?: number, endTime?: number, contentIssueTypeName?: string): Observable<string> {
    let queryParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (startTime) {
      queryParams = queryParams.set('startTime', <any>startTime);
    }
    if (endTime) {
      queryParams = queryParams.set('endTime', <any>endTime);
    }
    if (contentIssueTypeName) {
      queryParams = queryParams.set('contentIssueTypeName', <any>contentIssueTypeName);
    }
    return this.http.get<string>(this.contentIssueTypeApi + `/contentissuetype/report`, {params: queryParams, responseType: 'text' as 'json'});
  }
}
